import { Skeleton, Typography } from '@customink/pigment-react';
import {
  type ProjectItem,
  useProduct,
} from '@customink/project-service-react-components';
import startCase from 'lodash/startCase';

import { DelimitedSet } from '../DelimitedSet';

type ProjectItemDetailsProps = {
  item: ProjectItem;
};

export const ProjectItemDetails = ({ item }: ProjectItemDetailsProps) => {
  const { data: product } = useProduct({
    colorId: item.product?.colorId,
  });

  const selectedColor = product?.colors?.find(
    (color) => color.id === item.product?.colorId,
  );

  const decorationMethod =
    product?.decoration_method === 'screen'
      ? 'printing'
      : product?.decoration_method;

  return (
    <Typography fontSize="14.4px" lineHeight="1.25" variant="bodyShort1">
      <DelimitedSet
        elements={[
          selectedColor?.name || <Skeleton width="70px" />,
          startCase(decorationMethod),
        ]}
      />
    </Typography>
  );
};
